module.exports = __webpack_public_path__ + "static/img/zhengxiaoyue.abbe395.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mingpian/zhengxiaoyue.png
// module id = /aSd
// module chunks = 0